<template>
    <Select
        :model-value="modelValue"
        :selected-value="selectedOption?.label"
        :options="options"
        option-key="key"
        option-value="label"
        :disabled="disabled"
        @update:model-value="(option) => $emit('update:modelValue', option.key)"
    >
        <template #optionContent v-if="selectedOption">
            <div class="d-flex align-items-center">
                <img v-if="selectedOption.logo" class="method-logo mr-2" :src="selectedOption.logo" :alt="selectedOption.label" />
                <span class="text-truncate">{{ selectedOption.label }}</span>
            </div>
        </template>
        <template #optionItem="{option}">
            <div class="d-flex align-items-center">
                <img v-if="option.logo" class="method-logo mr-2" :src="option.logo" :alt="option.label" />
                <span class="text-truncate">{{ option.label }}</span>
            </div>
        </template>
    </Select>
</template>
<script>
import Select from "../../../components/new/form/select/AppSelect.vue";

import {
    CUSTOM_DELIVERY_METHOD,
    DeliveryIntegrationsEnum,
    getDeliveryIntegrationLogo,
    showDeliveryIntegration
} from "../../enums/DeliveryIntegrationsEnum";

export default {
    name: "DeliveryMethodSelect",
    components: {
        Select
    },
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    computed: {
        options() {
            const options = Object.values(DeliveryIntegrationsEnum).map(integration => ({
                key: integration,
                label: showDeliveryIntegration(integration),
                logo: getDeliveryIntegrationLogo(integration)
            }));

            options.push({
                key: CUSTOM_DELIVERY_METHOD,
                label: this.$t('labels.custom_delivery'),
                logo: null
            });

            return options;
        },
        selectedOption() {
            const option = this.options.find(option => option.key === this.modelValue) ?? null;

            return option;
        }
    }
}
</script>
<style scoped>
.method-logo {
    border-radius: 5px;
    object-fit: cover;
    object-position: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}
</style>
